// Compiler result to JSON file
    import { createComponent } from 'js/declViewModelService';
    import { registerDynImportEntry } from 'js/moduleLoader';
    import AwParseService from 'js/awParseService';
    import AwFilterService from 'js/awFilterService';
    import { getField } from 'js/utils';
    import { Fragment } from 'react';
    let filterSer = AwFilterService.instance;
    import AwPanelBody from 'viewmodel/AwPanelBodyViewModel';
import AwFlexRow from 'viewmodel/AwFlexRowViewModel';
import AwScrollpanel from 'viewmodel/AwScrollpanelViewModel';
import AwListFilter from 'viewmodel/AwListFilterViewModel';
import AwDefaultCell from 'viewmodel/AwDefaultCellViewModel';
import AwPanelFooter from 'viewmodel/AwPanelFooterViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
    

    

    /*
    ctx imports
    */
    
    const ctxImportObj = {  };
    

    /*
    dynamic import
    */
    registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));;

    /*
    view model
    */
    const declViewModelJson = {
    "schemaVersion": "1.0.0",
    "data": {
        "searchBox": {
            "displayName": "Search Users",
            "type": "STRING",
            "labelPosition": "NO_PROPERTY_LABEL"
        },
        "searchBoxPlaceHolder": {
            "dbValue": "{{i18n.searchString}}"
        }
    },
    "props": {
        "accsessionid": {
            "type": "string"
        },
        "libraryId": {
            "type": "string"
        },
        "collaborationspaceId": {
            "type": "string"
        }
    },
    "lifecycleHooks": {
        "onMount": "reveal"
    },
    "dataProviders": {
        "loadLibraries": {
            "action": "listLibraries",
            "response": "{{data.librariesFound}}",
            "totalFound": "{{data.totalFound}}",
            "selectionModelMode": "multiple"
        }
    },
    "actions": {
        "reveal": {
            "actionType": "dataProvider",
            "method": "loadLibraries"
        },
        "listLibraries": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": {
                "request": {
                    "method": "POST",
                    "url": "/acc/orchestrate",
                    "withCredentials": true,
                    "data": {
                        "additionalProperties": {
                            "searchInput": "{{data.searchBox.dbValue}}"
                        },
                        "query": "query listLibraries( $listLibrariesInput: ListLibrariesInput ) { listLibraries( listLibrariesInput: $listLibrariesInput) }",
                        "variables": {
                            "listLibrariesInput": {
                                "searchOptions": {
                                    "limit": 20,
                                    "skip": 0,
                                    "outputProperties": [
                                        "*"
                                    ]
                                }
                            }
                        }
                    }
                },
                "progressIndicatorPrefix": "catalog",
                "accsessionid": "{{props.accsessionid}}",
                "loadBydefault": true
            },
            "outputData": {
                "totalFound": "data.data.listLibraries.totalCount",
                "librariesFound": "data.data.listLibraries.libraryObjs"
            },
            "events": {
                "success": [
                    {
                        "name": "usePartSuccess",
                        "eventData": {
                            "eventName": "usePartSuccess",
                            "eventData": "{{librariesFound}}"
                        }
                    }
                ]
            },
            "deps": "js/accHttpService"
        },
        "addPartsintoLibraries": {
            "actionType": "JSFunctionAsync",
            "method": "createHttpRequest",
            "inputData": [
                {
                    "query": "mutation usePartsInLibraries( $usePartsInLibrariesInput: UsePartsInLibrariesInput ) { usePartsInLibraries( usePartsInLibrariesInput: $usePartsInLibrariesInput) }",
                    "variables": {
                        "usePartsInLibrariesInput": {
                            "parts": "{{ctx.selectedPartsList.items}}",
                            "libraries": "{{data.dataProviders.loadLibraries.selectedObjects}}",
                            "accId": "{{ctx.user.accsessionid}}"
                        }
                    }
                }
            ],
            "outputData": {
                "createdParts": "data.usePartsInLibraries"
            },
            "deps": "js/accHttpService"
        }
    },
    "onEvent": [],
    "i18n": {
        "searchString": [
            "DesLibraryMessages"
        ],
        "addButton": [
            "DesLibraryMessages"
        ]
    },
    "_viewModelId": "DesUsePart",
    "_uniqueViewModelId": "DesUsePart",
    "ctx": {
        "selectedPartsList": {
            "type": "object"
        },
        "user": {
            "type": "object"
        }
    }
};

    /*
    <aw-panel-body>
  <aw-flex-row>
    <aw-scrollpanel>
      <div class="des-image-styling-libraryList">
        <aw-list-filter prop="data.searchBox" dataprovider="data.dataProviders.loadLibraries">
          <aw-default-cell vmo="item"></aw-default-cell>
        </aw-list-filter>
      </div>
    </aw-scrollpanel>
  </aw-flex-row>
</aw-panel-body>
<aw-panel-footer>
  <aw-button action="addPartsintoLibraries" size="stretched">
    {{i18n.addButton}}</aw-button>
</aw-panel-footer>

    */
    const renderFn =(props)=> {
        let subPanelContext = props.subPanelContext ;
        let { viewModel: { data, dataProviders, dispatch, conditions, selectionModels, editHandlers, chartProviders, ports  }, grids, ctx, actions, fields, messages, i18n, formProp, viewPath  } = props;
        data = {...data, dataProviders};
        if( subPanelContext && subPanelContext.fields ){
            fields = { ...fields, ...subPanelContext.fields };
        }
        let $index = null;
        return (
            <Fragment>
    <AwPanelBody>
        <AwFlexRow>
            <AwScrollpanel>
                <div className="des-image-styling-libraryList">
                    <AwListFilter dataprovider={dataProviders.loadLibraries} showDropArea={null} dndHandler={props.viewModel.dndHandler} {...getField("data.searchBox", fields, $index, null, null )}>{({item, index})=>{ return <>                        <AwDefaultCell vmo={AwParseService.instance( "item" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports, item, index } )}>
                        </AwDefaultCell></> } }
                    </AwListFilter>
                </div>
            </AwScrollpanel>
        </AwFlexRow>
    </AwPanelBody>
    <AwPanelFooter>
        <AwButton action={actions.addPartsintoLibraries} size="stretched">
            {AwParseService.instance( "i18n.addButton" )( { props, data, fields, dataProviders, ctx, i18n, actions, subPanelContext, viewPath, conditions, formProp, dispatch, selectionModels, editHandlers, chartProviders, ports } )}
        </AwButton>
    </AwPanelFooter>
</Fragment>
        )
    };


    /*
    define component
    */
    const Component = createComponent( declViewModelJson, renderFn, undefined, ctxImportObj );

    export default Component;